module.exports = __webpack_public_path__ + "img/future1.9451d9a6.png";